'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'prescription-bottle';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'f485';
var svgPathData = 'M336 32c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16L48 96c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l288 0zM48 0C21.5 0 0 21.5 0 48L0 80c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48L48 0zM32 160l0 288c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-288-32 0 0 288c0 17.7-14.3 32-32 32L96 480c-17.7 0-32-14.3-32-32l0-32 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-64 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-64 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-32-32 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPrescriptionBottle = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;